// src/utils/anonymousUser.ts
import { v4 as uuidv4 } from 'uuid';

export const getAnonymousId = () => {
  const storageKey = 'anonymous_user_id';
  let userId = localStorage.getItem(storageKey);
  
  if (!userId) {
    userId = uuidv4();
    localStorage.setItem(storageKey, userId as string);
  }
  
  return userId;
};